var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mark-el"},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.markProps.title)+" ")]),_c('p',{staticClass:"num-contain"},[_c('span',{staticClass:"num"},[_vm._v(" "+_vm._s(_vm.markProps.num)+" ")]),_c('span',{staticClass:"percent"},[_vm._v(" "+_vm._s(_vm.markProps.percent)+" ")])]),_c('p',{staticClass:"contrast",style:({
      color: _vm.markProps.isRise?'red':'green'
    })},[_vm._v(" "+_vm._s(`环比上月：${_vm.markProps.toPercent}${_vm.markProps.isRise?'↑':'↓'}`)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }